import Store from '../../../Common/Store';
import http from 'mcc-front-aux/dist/httpCommon'
// import { trackPromise } from 'react-promise-tracker';
/* global fetch */

class TAPICall {
  constructor() {
    this.url = Store.getStoreData("base_api_url") + '/microservice/docmgmt/api/command'
    this.is_admin = Store.getStoreData("is_admin");
    this.is_debug = Store.getStoreData("is_debug");
    this.module_name = "docmgmt";
  }

  strRawToWeb(jsonDataString) {
    jsonDataString = jsonDataString.replace(/&/g, "--and--");
    jsonDataString = jsonDataString.replace(/\+/g, "--plus--");
    jsonDataString = jsonDataString.replace(/'+/g, "--quote--");
    jsonDataString = jsonDataString.replace(/\n/g, "--newline--");
    jsonDataString = jsonDataString.replace(/\r/g, "--creturn--");

    return jsonDataString
  }

  strWebToRaw(result) {
    result = result.replace(/(--plus--)/g, "+");
    result = result.replace(/(--quote--)/g, "'");
    result = result.replace(/(--and--)/g, "&");
    result = result.replace(/(--newline--)/g, "\n");
    result = result.replace(/(--creturn--)/g, "\r");
    result = result.replace(/'+/g, "'");

    return result
  }

  async command(postData, callback) {
    let url = this.url;
    postData.env = "select";

    let jsonDataString = this.strRawToWeb(JSON.stringify(postData))

    let postURL = url;

    if ('command' in postData) {
      postURL += `/${postData.command}`;
    }

    http.post(postURL, {jsondata: jsonDataString}).then(result => {
      result = result.data.body
      result = this.strWebToRaw(JSON.stringify(result));
      result = JSON.parse(result);
      let data = JSON.parse(result);
      callback(data);

    }).catch(error => {
      console.log('Error data',error);
      return null;
    });
  }
}

export default TAPICall;
